import { Box, Button, Typography } from "@mui/material";
import DataGridCustom from "components/DataGridCustom";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
import Header from "components/Header";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useGetAllRTOTransactionsQuery } from "state/api";
import { localFileUrl } from "../../../utils";

const RtoTab = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [sort, setSort] = useState({ field: "createdAt", sort: "desc" });

  const { data, isLoading } = useGetAllRTOTransactionsQuery({
    page,
    pageSize,
    sort: JSON.stringify(sort),
    search,
  }); // Fetching data from the API

  const userRole = useSelector((state) => state.auth.userInfo.role);

  const handleDownload = async (fileName, transactionId, BuyerName) => {
    // Downloading file from the API
    let url =
      process.env.REACT_APP_SERVER_APP_BASE_URL +
      "/transaction/file?transactionId=" +
      transactionId +
      "&fileName=" +
      fileName;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
        "Content-Disposition":
          "attachment; filename=" + BuyerName + "_" + fileName + ".pdf",
      },
    });

    // save file locally
    const blob = await response.blob();
    const file = new Blob([blob], { type: "application/pdf" });

    // download file
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(file);
    link.download = BuyerName + "_" + fileName + ".pdf";
    link.click();
  };

  const columns = [
    {
      field: "BuyerName",
      headerName: "Buyer Name",
      width: 200,
      valueGetter: (params) => {
        return params?.row?.Buyer?.name;
      },
      renderCell: (params) => {
        return <Typography>{params.value}</Typography>;
      },
    },
    {
      field: "carName",
      headerName: "Car Name",
      width: 300,
      valueGetter: (params) => {
        return params?.row?.carId?.name + " " + params?.row?.carId?.model;
      },
      renderCell: (params) => {
        // return Car.name from nested object
        return <Typography>{params.value}</Typography>;
      },
    },
    {
      field: "contact",
      headerName: "Contact",
      width: 200,
      valueGetter: (params) => {
        return params?.row?.Buyer?.contact[0];
      },
      renderCell: (params) => {
        // return Buyer.contact from nested object
        return <Typography>{params?.value}</Typography>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      valueGetter: (params) => {
        return params?.row?._id;
      },
      renderCell: (params) => {
        return (
          <>
            <Button
              className="bg-blue-500 hover:bg-blue-700 text-white"
              onClick={() => {
                window.open(`/transaction-rto-process?id=${params.value}`, "_self");
              }}
            >
              Continue
            </Button>
          </>
        );
      },
    },
    {
      field: "bookingForm",
      headerName: "Booking Form",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.bookingForm?._id;
      },
      renderCell: (params) => {
        return (
            <>
              {params.value && (
                <Button
                  className="bg-blue-500 hover:bg-blue-700 text-white"
                  onClick={() => {
                    handleDownload(
                      "bookingForm",
                      params?.row?._id,
                      params?.row?.Buyer?.name
                    );
                  }}
                >
                  View
                </Button>
              )}
            </>
          );
      },
    },
    {
      field: "balanceReceiptForm",
      headerName: "Balance Receipt Form",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.balanceReceiptForm?._id;
      },
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  handleDownload(
                    "balanceReceiptForm",
                    params?.row?._id,
                    params?.row?.Buyer?.name
                  );
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "deliveryNoteForm",
      headerName: "Delivery Note Form",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.deliveryNoteForm?._id;
      },
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  handleDownload(
                    "deliveryNoteForm",
                    params?.row?._id,
                    params?.row?.Buyer?.name
                  );
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "invoice",
      headerName: "Invoice",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.invoice?._id;
      },
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  handleDownload(
                    "invoice",
                    params?.row?._id,
                    params?.row?.Buyer?.name
                  );
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "aadharCard",
      headerName: "Aadhaar Card",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.Buyer?.aadharCard;
      },
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  window.open(localFileUrl(params?.value?.url), "_blank");
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "panCard",
      headerName: "Pan Card",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.Buyer?.panCard;
      },
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  window.open(localFileUrl(params?.value?.url), "_blank");
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "addressProof",
      headerName: "Address Proof",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.Buyer?.addressProof;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  window.open(localFileUrl(params?.value?.url), "_blank");
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "rtoDocument",
      headerName: "RTO Document",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.rto?.rtoFile;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  window.open(localFileUrl(params?.value), "_blank");
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
    {
      field: "insuranceDocument",
      headerName: "Insurance Document",
      width: 80,
      valueGetter: (params) => {
        return params?.row?.insurance?.insuranceFile;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.value && (
              <Button
                className="bg-blue-500 hover:bg-blue-700 text-white"
                onClick={() => {
                  window.open(localFileUrl(params?.value), "_blank");
                }}
              >
                View
              </Button>
            )}
          </>
        );
      },
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="RTO Work" subtitle="List of Pending RTO Transactions" />
      <DataGridCustom
        loading={isLoading || !data}
        getRowId={(row) => row._id}
        rows={(data && data.result) || []}
        columns={
          // align header to center
          columns.map((column) => ({
            ...column,
            headerAlign: "center",
            align: "center",
          }))
        }
        rowCount={(data && data.total) || 0}
        rowsPerPageOptions={[20, 50, 100]}
        pagination
        paginationMode="server"
        pageSize={pageSize}
        sortingMode="server"
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        onSortModelChange={(model) => {
          setSort(...model);
        }}
        components={{ Toolbar: DataGridCustomToolbar }}
        componentsProps={{
          toolbar: {
            searchInput,
            setSearchInput,
            setSearch,
            userRole,
            showSearch: false,
          },
        }}
        rowHeight={80}
        autoHeight
      />
    </Box>
  );
};

export default RtoTab;
